import { GridValidRowModel } from '@mui/x-data-grid-premium';
import { GridInitialStatePremium } from '@mui/x-data-grid-premium/models/gridStatePremium';
import { useContext } from 'react';
import { DataGridProWrapper } from 'shared/components/DataGridProWrapper';
import { useTableData } from 'shared/providers/provideTableData';
import { GridColumns, TableDataContext } from 'shared/types';
import { IPinnedColumnsProps, ManualSaveConfigProps } from './CustomToolbar';

export interface ITableDataPageConfigProps {
    initialState?: GridInitialStatePremium | undefined;
    hideExport?: boolean;
    manualSaveProps?: ManualSaveConfigProps;
    pinnedColumnsProps?: IPinnedColumnsProps;
}

type TableDataPageProps<T extends GridValidRowModel> = {
    tableDataContext: React.Context<TableDataContext<T>>;
    columnConfig: GridColumns<T>;
    title?: string;
    config?: ITableDataPageConfigProps;
    customToolbarChildren?: React.ReactNode[];
    isChildrenInlineWithGridToolbarComponents?: boolean;
};

export function TableDataPage<
    T extends {
        id: string;
    }
>({
    tableDataContext,
    columnConfig,
    title,
    config,
    customToolbarChildren,
    isChildrenInlineWithGridToolbarComponents,
}: TableDataPageProps<T>) {
    const { dataGridProProps, getExportHandler, isExportLoading, dataGridProManualSaveProps } = useTableData(
        tableDataContext,
        columnConfig
    );

    const { isRowEditLoading } = useContext(tableDataContext);

    return (
        <>
            <DataGridProWrapper
                title={title}
                dataGridProProps={dataGridProProps}
                getExportHandler={getExportHandler}
                isExportLoading={isExportLoading}
                dataGridProManualSaveProps={dataGridProManualSaveProps}
                config={config}
                customToolbarChildren={customToolbarChildren}
                isRowEditLoading={isRowEditLoading}
                isChildrenInlineWithGridToolbarComponents={isChildrenInlineWithGridToolbarComponents}
            />
        </>
    );
}
